import {store} from "../store/configureStore";
import {IResponse, requestWithToken} from "./RequestBase";
import {config} from "../config";


export const fetchVideoToken = async (): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.videoUrl}/api/video/token/auth`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            }
        },
        false,
        false
    );

    // if (data?.status === 200) {
    //     const video: IVideo = data.data;
    //     store.dispatch(actionVideo.setVideo(video))
    // }
    return data;
}

export const fetchVideoLink = async (): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.videoUrl}/api/video/links`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            }
        },
        false,
        true
    );
    return data;
}

export const fetchVideoToggleStream = async (flag: boolean = false): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.videoUrl}/api/video/` + (flag ? 'stop' : 'start'),
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            }
        },
        false,
        true
    );
    return data;
}

